import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';
import { useAppSelector, useAppDispatch } from '../../../infra/hooks';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';
import { useTranslation } from 'react-i18next';
import { changeApplang } from '../../configs/utils';
import { userService } from '../../../api/services/userService';
import { setEmployeeCompanyData } from '../../../infra/aggregates/employeeCompanySlice';
import { createSocketConnection } from '../../WS/wsService';
import { setException } from '../../../infra/aggregates/Exception';
import { attendanceException } from '../../../api/services/attendanceException';
import { dashboardService } from '../../../api/services/dashboardService';
import { setConigMenu } from '../../../infra/aggregates/sideMenuSlice';

const Shell: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const auth_token = useAppSelector((state) => state.authTokenSlice.authToken);
  const companyId = useAppSelector((state) => state.authSlice?.company_id);
  const userId = useAppSelector((state) => state.authSlice?.user_id);
  const stored_companyLogo = useAppSelector(
    (state) => state.employeeCompanySlice.logo,
  );

  const [render, setRender] = useState(false);
  function listen(
    callBack: (payload: any) => void,
    channel: string,
    event: string,
  ) {
    // window.Echo.connect();
    window.Echo.channel(channel)
      .listen(event, (payload: any) => {
        callBack(payload);
      })
      .subscribed(() => {
        //
      })
      .error(() => console.log('Error in subscriptions'));

    return function cleanUp() {
      window.Echo.leaveChannel(channel);
    };
  }
  const locale = localStorage.getItem('emplang');

  useEffect(() => {
    attendanceException
      .isExceptionEnabled({ company_id: companyId })
      .then((response: any) => {
        const isEnabled: any = response?.isatteexceptions == 1 ? true : false
        dispatch(setException(isEnabled))
      })
    dashboardService
      .getConfigMenuList(userId, locale)
      .then((res: any) => {
        dispatch(setConigMenu(res));
      });
  }, []);

  useEffect(() => {
    if (auth_token) {
      setRender(true);
      const newlang: any = localStorage.getItem('emplang');
      const _lang = newlang ? newlang : 'en';
      i18n.changeLanguage(_lang);
      changeApplang(_lang, false);
      if (!stored_companyLogo && companyId > 0) {
        userService
          .getCompanDetail(companyId)
          .then((response: any) => {
            if (response.response == 'success') {
              dispatch(setEmployeeCompanyData({ logo: response?.data?.logo }));
            }
          })
          .catch((err) =>
            console.log('error while getting company detail for employee', err),
          );
      }
    } else {
      navigate('/login');
    }
  }, []);

  useEffect(() => {
    createSocketConnection();
    return listen(
      function (response) {
        toast.success(response?.data?.notifiable_type)
      },
      `public.action.required.${companyId}.${userId}.2`,
      '.actionrequired',
    );
  }, [])

  return (
    <div>
      {render && (
        <div>
          <Toaster
            toastOptions={{
              style: {
                maxWidth: 500,
              },
            }}
          />

          <Grid
            className="main-body"
            container
            style={{
              maxWidth: 'auto',
              height: '100vh',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <>
              {children}
              <Footer />
            </>
          </Grid>
        </div>
      )}
    </div>
  );
};

export default Shell;
